import axios from 'axios';
import humps from 'humps';
import cloneDeep from 'lodash/cloneDeep';

const BACKEND_BASE_URL = '/api/v1';

const CONTENTFUL_BASE_URL = 'https://cdn.contentful.com/spaces/vuv4pzcbmxh6';
const CONTENTFUL_AUTH_TOKEN =
  '9ec901435904dd42de6df868aef50b32b7f94432e59c68b9050dcf14416d7cb9';

// Backend API

const backend = axios.create({ baseURL: BACKEND_BASE_URL });
const backendHeaders = cloneDeep(backend.defaults.headers);

backendHeaders.common['Accept'] = 'application/json';
backendHeaders.common['Content-Type'] = 'application/json';

backend.defaults.headers = backendHeaders;

backend.interceptors.request.use(request => ({
  ...request,
  data: humps.decamelizeKeys(request.data)
}));

backend.interceptors.request.use(request => ({
  ...request,
  data: humps.decamelizeKeys(request.data)
}));

backend.interceptors.response.use(response => ({
  ...response,
  data: humps.camelizeKeys(response.data)
}));

// Contentful API

const contentful = axios.create({ baseURL: CONTENTFUL_BASE_URL });
const contentfulHeaders = cloneDeep(contentful.defaults.headers);

contentfulHeaders.common['Authorization'] = `Bearer ${CONTENTFUL_AUTH_TOKEN}`;

contentful.defaults.headers = contentfulHeaders;

// Export

const api = {
  backend,
  contentful
};

export default api;



// WEBPACK FOOTER //
// ./src/helpers/api.js